var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FF5963"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7051 18.4062L33.4766 36.7754H30.541L30.2949 18.4062H33.7051ZM30.1895 42.3652C30.1895 41.8379 30.3477 41.3926 30.6641 41.0293C30.9922 40.666 31.4727 40.4844 32.1055 40.4844C32.7266 40.4844 33.2012 40.666 33.5293 41.0293C33.8691 41.3926 34.0391 41.8379 34.0391 42.3652C34.0391 42.8691 33.8691 43.3027 33.5293 43.666C33.2012 44.0293 32.7266 44.2109 32.1055 44.2109C31.4727 44.2109 30.9922 44.0293 30.6641 43.666C30.3477 43.3027 30.1895 42.8691 30.1895 42.3652Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.015898b21072fde2f9ca56a58a62eebf.svg";
export { ForwardRef as ReactComponent };